import { formatPrice } from './formatPrice';

export function generateOrderNumber() {
  const randomNum = Math.floor(100000 + Math.random() * 900000);
  return `WZ-${randomNum}`;
}

export function formatOrderMessage(cartItems, customerInfo, orderNumber) {
  const itemsList = cartItems.map((item, index) => {
    const itemTotal = item.price * item.quantity;
    const sizeInfo = item.size ? ` (${item.size})` : '';
    let itemText = `${index + 1}. *${item.name}*${sizeInfo}\n   Qty: ${item.quantity} | Price: ${formatPrice(itemTotal)}`;
    if (item.packageItems && item.packageItems.length > 0) {
      const packageBreakdown = item.packageItems.map(p => `   • ${p.name} (${p.size})`).join('\n');
      itemText += `\n   *Package Includes:*\n${packageBreakdown}`;
    }
    return itemText;
  }).join('\n\n');

  const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const deliveryFee = subtotal >= 3000 ? 0 : 200;
  const total = subtotal + deliveryFee;

  let message = `*NEW ORDER — ${orderNumber}*\n`;
  message += `━━━━━━━━━━━━━━━━━━━━━\n\n`;
  message += `*ORDER ITEMS:*\n${itemsList}\n\n`;
  message += `━━━━━━━━━━━━━━━━━━━━━\n`;
  message += `*Subtotal:* ${formatPrice(subtotal)}\n`;
  message += `*Delivery:* ${deliveryFee === 0 ? 'FREE' : formatPrice(deliveryFee)}\n`;
  message += `*TOTAL: ${formatPrice(total)}*\n`;
  message += `_(Cash on Delivery)_\n\n`;
  message += `━━━━━━━━━━━━━━━━━━━━━\n`;
  message += `*CUSTOMER DETAILS:*\n`;

  if (customerInfo.name) {
    message += `• *Name:* ${customerInfo.name.trim()}\n`;
  }
  if (customerInfo.phone) {
    message += `• *Phone:* ${customerInfo.phone.trim()}\n`;
  }
  if (customerInfo.city) {
    message += `• *City:* ${customerInfo.city.trim()}\n`;
  }
  if (customerInfo.address) {
    message += `• *Address:* ${customerInfo.address.trim()}\n`;
  }
  if (customerInfo.notes && customerInfo.notes.trim()) {
    message += `• *Notes:* ${customerInfo.notes.trim()}\n`;
  }

  message += `\n━━━━━━━━━━━━━━━━━━━━━\n`;
  message += `I would like to place this order. Please confirm. Thank you!`;

  return message;
}